import {
  ConversationsChannels,
  MetaConversation,
} from 'lib-shared-legacy-types';

import { numberFormatterInternational } from './telephonyHelpers';

export const isAudioChannel = (channel?: null | string): boolean => {
  return (
    channel === 'pstnphone' || channel === 'callback' || channel === 'voicemail'
  );
};

/** The default character limit allowed per channel. */
export const defaulMaxMessageLength = 50000;

export const smsMaxMessageLength = 1600;
const facebookMaxMessageLength = 1000;
const whatsappMaxSmsMessageLength = 4096;
const twitterTweetMaxMessageLength = 280;
const twitterDMMaxSmsMessageLength = 10000;

/**
 * A record to map the channel with their message length limit. The first
 * element of the tuple value represents the default channel message length,
 * whereas the second is the alternative optional one.
 */
const maxMessageLengthPerChannel: Partial<
  Record<ConversationsChannels, [number, number?]>
> = {
  facebookmessenger: [facebookMaxMessageLength],
  whatsapp: [whatsappMaxSmsMessageLength],
  sms: [smsMaxMessageLength],
  twitter: [twitterDMMaxSmsMessageLength, twitterTweetMaxMessageLength],
};

export const getChannelMessageMaxLength = (
  channel: string,
  isPublic?: boolean,
): number => {
  if (maxMessageLengthPerChannel[channel]) {
    return isPublic && maxMessageLengthPerChannel[channel][1]
      ? maxMessageLengthPerChannel[channel][1]
      : maxMessageLengthPerChannel[channel][0] ?? defaulMaxMessageLength;
  }
  return defaulMaxMessageLength;
};

export const getMetaConversationName = (
  metaConversation: MetaConversation,
): string => {
  const { requester, conversation } = metaConversation;
  if (requester?.name) {
    return requester.name;
  }

  if (requester?.phone_number && isAudioChannel(conversation.initial_channel)) {
    try {
      const phoneNumber = numberFormatterInternational({
        phoneNumber: requester.phone_number,
      });
      return phoneNumber;
    } catch (exception) {
      return requester.phone_number;
    }
  }

  if (requester?.email) {
    return requester.email;
  }

  return 'Unknown';
};
